module.exports = __webpack_public_path__ + "img/not-found.e82b3049.svg";